
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comprar-grama",
      function () {
        return require("private-next-pages/comprar-grama/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comprar-grama"])
      });
    }
  